<template>
  <v-app>
    <app-header></app-header>
      <v-content>
        <router-view></router-view>
      </v-content>
  </v-app>
</template>

<script>
import AppHeader from './components/shared/header.vue'
import {mapActions, mapState} from 'vuex'

export default {
  data () {
    return {
      
    }
  },
  components: {
    AppHeader,
  },
  computed: {
    is_ready() {
      return this.$auth.ready() 
    }
  },
  methods: {
    ...mapActions({
      setUser: 'Users/setUser',
    }),
    verClick(title){
      if(title == 'Perfil'){
        console.log('clicou no perfil, ')
        // this.setUser(1)   
      }
    },
  },
  watch: {
    is_ready(nv,ov) {
      if (nv){
        this.setUser(this.$auth.user())
      } else if (nv == false){
  
      }
    }
  },
}
</script>

<style scoped>
.logo{
  width: 80px !important;
  height: auto;
  margin-top: 10px;
}
</style>
